<template>
    <div id="app" class="app">
        <layout v-if="isLoggedIn && hasUser" />
        <auth-layout v-else />
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import Layout from './components/layout/Layout'
import AuthLayout from './components/layout/AuthLayout'
export default {
    name: 'app',
    components: {
        AuthLayout,
        Layout
    },
    computed: {
        ...mapState({
            isLoggedIn: ({ me }) => me.isLoggedIn,
            token: ({me}) => me.token
        }),
        ...mapGetters(['hasUser', 'user'])
    }
}
</script>

<style lang="stylus">
@import './stylus/variables'
@import './stylus/main'
</style>
